<template>
  <div class="invite-reward">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="hint">
            直邀提现奖励-----直邀用户累计<strong>提现金额</strong>达到门槛后，邀请人可获得对应<strong>奖励金额</strong>
          </div>
          <div class="action-group">
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增档位</el-button>
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty v-else-if="!loading && list.length === 0" description="暂无奖励配置" />

      <div v-else>
        <el-table
          :data="list"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载..."
          row-key="id"
        >
          <el-table-column prop="id" label="ID" width="70" align="center" />
          <el-table-column prop="minDirectWithdraw" label="直邀累计提现≥(元)" min-width="150" align="center" />
          <el-table-column prop="rewardAmount" label="邀请人奖励(元)" min-width="130" align="center" />
          <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
              <el-tag v-else type="info" size="small">禁用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button type="text" size="small" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑档位' : '新增档位'"
      :visible.sync="dialogVisible"
      width="480px"
      append-to-body
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="140px">
        <el-form-item label="直邀累计提现≥" prop="minDirectWithdraw">
          <el-input-number
            v-model="form.minDirectWithdraw"
            :min="0"
            :precision="2"
            :step="0.1"
            controls-position="right"
          />
          <div class="form-tip">仅统计直推下级实际提现金额（元，最多2位小数）</div>
        </el-form-item>
        <el-form-item label="邀请人奖励" prop="rewardAmount">
          <el-input-number
            v-model="form.rewardAmount"
            :min="0.01"
            :precision="2"
            :step="0.1"
            controls-position="right"
          />
          <div class="form-tip">达到该门槛后邀请人可获得的奖励金额（元，最多2位小数）</div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="form.remark"
            maxlength="100"
            placeholder="自动生成，可修改"
            @input="onRemarkInput"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { get, post, put, del, getResponseMessage } from '@/utils/http.js'

export default {
  name: 'InviteReward',
  data() {
    return {
      loading: false,
      submitting: false,
      error: '',
      list: [],
      pagination: { page: 1, pageSize: 20, total: 0 },
      dialogVisible: false,
      isEdit: false,
      editId: null,
      form: this.emptyForm(),
      lastAutoRemark: '',
      remarkManual: false,
      rules: {
        minDirectWithdraw: [{ required: true, message: '请输入直邀累计提现门槛', trigger: 'blur' }],
        rewardAmount: [{ required: true, message: '请输入奖励金额', trigger: 'blur' }]
      }
    }
  },
  watch: {
    'form.minDirectWithdraw'() {
      this.syncAutoRemark()
    },
    'form.rewardAmount'() {
      this.syncAutoRemark()
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    buildAutoRemark() {
      const min = this.form.minDirectWithdraw
      const reward = this.form.rewardAmount
      if (min == null || reward == null || min === '' || reward === '') {
        return ''
      }
      return `直邀累计提现≥${min}元，奖励${reward}元`
    },
    syncAutoRemark() {
      if (this.remarkManual) return
      const auto = this.buildAutoRemark()
      this.lastAutoRemark = auto
      this.form.remark = auto
    },
    onRemarkInput(val) {
      const auto = this.buildAutoRemark()
      this.remarkManual = val !== auto
      if (!this.remarkManual) {
        this.lastAutoRemark = auto
      }
    },
    emptyForm() {
      return {
        minDirectWithdraw: 20,
        rewardAmount: 3,
        remark: '直邀累计提现≥20元，奖励3元',
        status: 1
      }
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const res = await get('/admin/invite-reward/page', {
          pageNum: this.pagination.page,
          pageSize: this.pagination.pageSize
        })
        const data = res.data || {}
        this.list = data.records || []
        this.pagination.total = data.total || 0
      } catch (e) {
        this.list = []
        this.error = e.message || '加载失败'
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.isEdit = false
      this.editId = null
      this.remarkManual = false
      this.form = this.emptyForm()
      this.lastAutoRemark = this.form.remark
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleEdit(row) {
      this.isEdit = true
      this.editId = row.id
      this.form = {
        minDirectWithdraw: row.minDirectWithdraw,
        rewardAmount: row.rewardAmount,
        remark: row.remark || '',
        status: row.status == null ? 1 : row.status
      }
      const auto = this.buildAutoRemark()
      this.lastAutoRemark = auto
      // 备注为空或仍是自动文案时，后续改数字继续同步；手动改过的保留
      this.remarkManual = !!(this.form.remark && this.form.remark !== auto)
      if (!this.form.remark) {
        this.form.remark = auto
        this.remarkManual = false
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    handleSubmit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await put(`/admin/invite-reward/${this.editId}`, this.form)
            this.$message.success('更新成功')
          } else {
            await post('/admin/invite-reward', this.form)
            this.$message.success('创建成功')
          }
          this.dialogVisible = false
          this.fetchList()
        } catch (e) {
          this.$message.error(getResponseMessage(e) || e.message || '保存失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm(`确定删除门槛「≥${row.minDirectWithdraw}」的奖励配置吗？`, '提示', { type: 'warning' })
        .then(async () => {
          try {
            await del(`/admin/invite-reward/${row.id}`)
            this.$message.success('已删除')
            this.fetchList()
          } catch (e) {
            this.$message.error(getResponseMessage(e) || e.message || '删除失败')
          }
        })
        .catch(() => {})
    },
    handleCurrentChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}
.hint {
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
  flex: 1;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
.danger-text {
  color: #f56c6c;
}
.form-tip {
  color: #94a3b8;
  font-size: 12px;
  line-height: 1.4;
  margin-top: 4px;
}
</style>
